import { DRAG_ELEMENT, RESIZE } from './mutation-types'

export default {
  dragElement: ({ commit }, payload) => {
    commit(DRAG_ELEMENT, payload)
  },

  resize: ({ commit }) => {
    commit(RESIZE)
  },
}
